module.exports = __webpack_public_path__ + "static/media/canalboldromain.a32a9ee9.woff2";